import { CircularProgress } from '@mui/material'
import { IconButton } from 'components/core/IconButton'
import Row from 'components/core/Row'
import Typography from 'components/core/Typography'
import { DESIGN_TOKENS } from 'constants/color.constants'
import { SPACING } from 'constants/spacing.constants'
import { showToastError } from 'hooks/useToast'
import { Download } from 'lucide-react'
import { useState } from 'react'

type ChatMessageAttachmentProps = {
    filename: string
    onDownload: () => Promise<void>
    onDownloadSuccess: () => void
}

export const ChatMessageAttachment = ({
    filename,
    onDownload,
    onDownloadSuccess,
}: ChatMessageAttachmentProps) => {
    const [isDownloading, setIsDownloading] = useState(false)

    const _onDownload = async () => {
        setIsDownloading(true)

        try {
            await onDownload()
            onDownloadSuccess()
        } catch (e) {
            showToastError('Error downloading attachment')
        } finally {
            setIsDownloading(false)
        }
    }

    return (
        <Row p="p1" gap="p1" alignItems="center" justifyContent="space-between">
            <Typography color="primary" variant="body2">
                {filename}
            </Typography>
            <IconButton
                disabled={isDownloading}
                size="sm"
                onClick={_onDownload}
            >
                {isDownloading ? (
                    <CircularProgress
                        size={16}
                        style={{
                            color: DESIGN_TOKENS.text.foreground,
                        }}
                    />
                ) : (
                    <Download size={SPACING.p2} />
                )}
            </IconButton>
        </Row>
    )
}
